<template>
  <div class="detailsBg">

    <template>
      <div class="details" id="resumeDetails" @click.stop="hideDetails()">
        <!-- 内容区域 -->
        <div class="content bg_fff pr" @click.stop>

          <resumeDetail  :showBuyPhoneCount="false" :informationBlur="informationBlur" />

          <div class="pa tipsToUserInfo f_14 text_center" v-if="!userInfoState && detailType!=='delivery'&& listOptions.resumeIndex>=5 && !superShowView">
            <a class="text cursor_p color_blue" href="/talent/binduser" target="_blank"><span class="iconfont icontishi2"></span><span class="color_blue">完善个人信息</span><span> 后即可查看完整简历</span></a>
          </div>
        </div>

      </div>
      <!-- 分享弹窗 -->
      <shareBox v-if="showShareState" :token="token" className='tipsState1' @toggleShareState="toggleShareState" />

      <!-- 申请简历弹窗 -->
      <resume-apply v-if="showResumeApplyState"
        @resumeApply="resumeApply" @hideResumeApply="hideResumeApply" />

      <!-- 右侧方法集合-普通 -->
      <div class="rightFunction pa" @click.stop="hideDetails()" v-if="pageName !=='talentJobList'">
        <div class="functions text_center" @click.stop>
          <div class="item bg_fff f_14 color_60" :class="[detailState.getPhoneState || getPhoneNumber<1 || ( resumeDetail.hr_permission_state==='rejected' || resumeDetail.hr_permission_state==='passed') ? 'disabled' : 'cursor_p']"  v-if="resumeDetail.visibility==='in_public' || resumeDetail.visibility==='hr_visible'" @click="getPhone()" >查看电话 ({{getPhoneNumber}})</div>
          <template>
            <div class="item bg_fff f_14 color_60 cursor_p" v-if="!resumeDetail.unsuited" @click="unsuitable()">不感兴趣</div>
            <div class="item bg_fff f_14 color_60 disabled" v-else>已标记不感兴趣</div>
          </template>
          
          <!-- 邀约状态判断 -->
          <template>
            <div class="item bg_fff f_14 color_60 cursor_p" v-if="!resumeDetail.hr_permission_state && !( resumeDetail.visibility==='in_destroyed')" @click="resumeApply()" >联系Ta</div>
            <div class="item bg_fff f_14 color_60 cursor_p" v-else @click="toChatPage()">继续沟通</div>
            <!-- <div class="item bg_fff f_14 color_60 cursor_p" v-if="resumeDetail.hr_permission_state==='applied' && !( resumeDetail.visibility==='in_destroyed')" @click="resumeApply('applied')" >待通过</div>
            <div class="item bg_fff f_14 color_60 disabled" v-if="resumeDetail.hr_permission_state==='rejected' && !( resumeDetail.visibility==='in_destroyed')" >已拒绝</div>
            <div class="item bg_fff f_14 color_60 disabled" v-if="resumeDetail.hr_permission_state !=='passed' && ( resumeDetail.visibility==='in_destroyed')" >暂不看机会</div> -->
          </template>
        </div>
      </div>

    </template>

  </div>
</template>

<script>
import { Base64 } from 'js-base64';

//混入优化
import { mixinsUtils } from '@/mixins/search/utils';
import { mixinsDetails } from '@/mixins/search/details';

import {checkUserState, get_tUser } from '@/utils/utils';

//高亮搜索关键词的字段
import { highlighter_education_experiences, highlighter_work_experiences, highlighter_orgs, highlighter_custom_sections, highlighter_others } from '@/utils/resumeDetailUtils'

// 所有接口
import actions from '@/actions/index'

import { mapState, mapMutations, mapActions } from 'vuex'

// 分享弹窗
import ShareBox from '@/components/block/ShareBox'
//申请简历
import ResumeApply from '@/components/block/ResumeApply'
// 简历详情
import resumeDetail from '@/components/resumeDetail'
/* visibility 参数：
in_public = 0  # 简历公开可见除了电话邮箱所有信息
hr_visible = 1  # 只可可见简要信息
in_private = 2  # 隐私状态
in_destroyed = 3  # 已删除
*/

export default {
  name: 'searchDatails',
  mixins:[mixinsUtils, mixinsDetails],
  props:{
    selectedeXperience:{
      type: Array,
      default: ()=>[]
    },
    favoritesId:{
      type: String,
      default: ''
    },
    detailType:{ //简历类型 delivery：新投递,
      type: String,
      default: 'detail'
    },
    detailItem:{
      type: Object,
      default: ()=>{}
    },
    notfindResume: {
      type: Boolean,
      default: false
    },
    
  },
  data(){
    return {
      token:'',
      showResumeApplyState:false, //是否显示申请简历弹窗
      showShareState:false,// 是否显示分享弹窗

      downloadFile:{
        url:'',
        name:'超级简历.pdf',
      },
      VUE_APP_ENV_TYPE:process.env.VUE_APP_ENV_TYPE,

      detailState:{
        getPhoneState:false, //是否已经获取联系方式
        showGetPhone:false, //显示获取联系方式弹窗
      },
      checkRequestState:{ //接口请求状态
        resumeApply:false,
        downLoad:false,
      },
      superShowView:false,
      pageName:'', //页面名称
    }
  },
  computed:{
    ...mapState('block',['userInfoState','userinfoTipsState','getPhoneNumber']),
    ...mapState('delivery',['deliveryList','deliveryTotalCount','deliveryIndex']),
    ...mapState('resumeDetails',['resumeDetail', 'resumeDetailOptions', 'myPosition', 'listOptions',]),
    ...mapState('im',['hr_account_token']),
    informationBlur : function(){
      return !this.userInfoState && this.detailType!=='delivery'&& !(this.listOptions.page_size==1 && this.listOptions.resumeIndex<5) &&!this.superShowView
    },
  },
  components:{
    'shareBox':ShareBox,
    ResumeApply,
    resumeDetail
  },
  created(){
    this.checkData();
    if(this.favoritesId){
      this.resumeCollect(this.favoritesId)
    };
    this.token = this.resumeDetail.resume.token;
    let { abc } = this.$route.query;
    if(abc){
      let tokenStr = Base64.decode(abc);
      let { token } = this.resumeDetail.resume;
      let tokenStrSplit = tokenStr.split('adsk1ada-jkfla').filter(item=>item);
      if(tokenStrSplit.length){
        tokenStrSplit = tokenStrSplit[0].split('ki1-adiadm')[0];
      }
      this.superShowView = (token === tokenStrSplit)
    }
    // 当前页面名称
    this.pageName = this.$route.name

    document.body.style.position = 'static'
    document.body.style.overflow = 'hidden';
  },
  methods:{
    ...mapMutations('block',['toggleUserInfoState','toggleUserinfoTips', 'IsFavorites', 'toggleTipsType','updatePhoneNumber']),
    ...mapMutations('delivery',['updateDeliveryIndex']),
    ...mapMutations('resumeDetails',['updateResumeDetail']),
    ...mapActions('resumeDetails',['getMyPosition']),
    
    async checkData(){
      let user = get_tUser();
      if(user.h_t){
        // 获取直接查看联系人信息次数
        this.getContactInfoCounts();
      }
    },
    
    // 隐藏简历详情
    hideDetails(){
      this.$emit('hideDetails')
    },
    // 收藏/取消收藏
    async resumeCollect(token2){
      //检查是否完善信息，及更换用户
      const checkUser = await checkUserState({
        //不是hr
        callback1:()=>{
          // this.$router.replace({name:'talentSearchIndex'});
          // return false;
        },
        callback2:()=>{
          //列表回到第一页，刷新数据
          location.reload();
          return false;
        },
      });

      let token = token2 || this.resumeDetail.resume.token;
      let is_favorite = this.resumeDetail.is_favorite;

      //引导用户完善信息弹层
      if(!this.userInfoState){
        
        let user = get_tUser();
        if(user.h_t){
          //更新是否完善信息(状态库)
          let userInfo = await actions.hr_accounts.getUserinfo();
          this.toggleUserInfoState(userInfo)
        }
        if(!this.userInfoState){
          //提示
          this.toggleUserinfoTips(true)
          //通知状态库
          this.IsFavorites(token)
          return false;
        }
      }
      //通知状态库
      this.IsFavorites('');
      
      let data = {
        token,
        type: is_favorite ? 'dislike' : 'like'
      }

      actions.favorites.favorites_status(data).then(res=>{
        if(res.code === 1000){
          this.resumeDetail.is_favorite = this.resumeDetail.is_favorite ? false : true;
          this.updateResumeDetail(this.resumeDetail)
          this.$message({
            message: is_favorite?'移除成功':'已添加至储备人才',
            type: 'success'
          });
          this.$emit('changeListState',{type:'is_favorite',value:this.resumeDetail.is_favorite})
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    // 申请
    async resumeApply(state, queryData){

      //检查是否完善信息，及更换用户
      const checkUser = await checkUserState({
        //不是hr
        callback1:()=>{
          // this.$router.replace({name:'talentSearchIndex'});
          // return false;
        },
        callback2:()=>{
          //列表回到第一页，刷新数据
          location.reload();
          return false;
        },
      });

      //引导用户完善信息弹层
      if(!this.userInfoState){
        let user = get_tUser();
        if(user.h_t){
          //更新是否完善信息(状态库)
          let userInfo = await actions.hr_accounts.getUserinfo();
          this.toggleUserInfoState(userInfo)
        }
        if(!this.userInfoState){
          //提示
          this.toggleUserinfoTips(true)
          return false;
        }
      }
      if(state === 'applied'){
        this.$message({
          message: '人才已收到邀约！继续联系更多人才获得回复率更高哦~',
          type: 'warning'
        });
        return false;
      }
      
      if(!this.showResumeApplyState){
        //更新职位列表
        try {
          await this.getMyPosition()
        } catch (error) {}
        if(!this.myPosition.list.length){
          //提示
          this.toggleUserinfoTips(true)
          //更新信息弹层 提示文案类型
          this.toggleTipsType(2)
          return false;
        }
        this.showResumeApplyState = true;
        return false;
      }
      if(this.checkRequestState.resumeApply){
        return false;
      }
      this.checkRequestState.resumeApply = true;
      queryData.token = this.token;
      //增加涞源
      queryData.way = 'recommend';
      queryData.job_id = this.resumeDetail.job_id;

      //上报发出邀约
      await actions.resumes.putRecommendations(this.token,{
        type:'invitation',
        way: 'recommend', //页面
        platform: 'pc_browser', //终端
        job_id: this.resumeDetail.job_id
      });
      
      actions.resume_permissions.application( queryData ).then((res)=>{
        this.checkRequestState.resumeApply = false;
        if(res.code === 1000){
          this.$message({
            message: '人才已收到邀约！继续联系更多人才获得回复率更高哦~',
            type: 'success'
          });
          //改变详情状态
          this.resumeDetail.hr_permission_state='applied';
          this.updateResumeDetail(this.resumeDetail)

          //通知列表改变状态
          this.$emit('changeListState',{type:'hr_permission_state',value:'applied'});
          //隐藏收藏弹窗
          this.hideResumeApply();
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })

    },
    //隐藏收藏弹窗
    hideResumeApply(){
      this.showResumeApplyState = false;
    },
    //【分享】显示弹窗
    toggleShareState(state){
      if(state){
        document.body.style.position = 'static'
        document.body.style.overflow = 'hidden'
      }else{
        document.body.style.position = 'initial'
        document.body.style.overflow = 'initial'
      }
      this.showShareState = state;
    },
    //返回加粗标题
    bigTitle(title,description){
      return `<span style="font-weight: bold !important;">${title}</span>：${description}`
    },
    //下载
    async downLoad(isDelivery){
      //检查是否完善信息，及更换用户
      const checkUser = await checkUserState({
        //不是hr
        callback1:()=>{
          this.$router.replace({name:'talentSearchIndex'});
          return false;
        },
        callback2:()=>{
          //列表回到第一页，刷新数据
          location.reload();
          return false;
        },
      });
      let { token, info } = this.resumeDetail.resume;
      let { profile, education_experiences } = info;
      let query = {
        token: token,
        type: 'base64'
      }
      //新投递下载判断
      if(isDelivery){
        let { has_email_attachemnt, job_application_id } = this.detailItem;
        if(!has_email_attachemnt){
          this.$message({
            message: '暂无附件简历',
            iconClass:'el-icon-error',
          });
          return false;
        }
        query.type = 'attachment_cv';
        query.job_application_id = job_application_id;
      }
      if(this.checkRequestState.downLoad){
        return false;
      }
      this.checkRequestState.downLoad = true;
      let downloadLoading =  this.$message({
        message: '正在下载',
        iconClass:'el-icon-loading',
        duration:0,
      });
      actions.resumes.downloads(query).then((res)=>{
        this.checkRequestState.downLoad = false;
        downloadLoading.close();
        if(res.code ===1000){
          this.$message({
            message: '获取简历文件成功',
            type: 'success'
          });
          let { bind_recruit_name, pdf} = res.data;
          let pdfName = '';
          let pdfUrl = `data:application/pdf;base64,${pdf}`;
          if(bind_recruit_name){
            pdfName = `${bind_recruit_name}-${profile.username}-超级简历`
          }else{
            let name = this.getFileName(info);
            pdfName = `${name}${profile.username}-超级简历`
          }

          var downloadJS = require('downloadjs');
          downloadJS(pdfUrl, pdfName, "application/pdf");

        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    //返回 满足条件的内容【有职位 或者 学校名称】
    getFileName(info){
      let { years_of_work_experience } = this.resumeDetail;
      let { education_experiences, work_experiences } = info;

      let name = '';
      let workIndex = -1;
      work_experiences && work_experiences.forEach((item,index) => {
        if(item.title && workIndex<0){
          workIndex = index;
          name = item.title.split('<i class="es-highlighter">').join('').split('</i>').join('');
        }
      });
      return name.length ? name+'-' : '';
    },

    //获取直接查看联系人信息次数
    async getContactInfoCounts(){
      let res = await actions.resumes.getContactInfoCounts({});
      if(res.code === 1000){
        this.updatePhoneNumber(res.data.check_contact_count )
      }else{
        this.updatePhoneNumber(0)
      }
    },

    //【手机号】获取获取手机号
    async getPhone(){
      //检查是否完善信息，及更换用户
      const checkUser = await checkUserState({
        //不是hr
        callback1:()=>{
          // this.$router.replace({name:'talentSearchIndex'});
          // return false;
        },
        callback2:()=>{
          //列表回到第一页，刷新数据
          location.reload();
          return false;
        },
      });

      //引导用户完善信息弹层
      if(!this.userInfoState){
       let user = get_tUser();
        if(user.h_t){
          //更新是否完善信息(状态库)
          let userInfo = await actions.hr_accounts.getUserinfo();
          this.toggleUserInfoState(userInfo)
        }
        if(!this.userInfoState){
          //提示
          this.toggleUserinfoTips(true);
          return false;
        }
      }

      if(!this.myPosition.list.length){
        //没有职位，检测一下
        await this.getMyPosition()
        if(!this.myPosition.list.length){
          //提示
          this.toggleUserinfoTips(true)
          //更新信息弹层 提示文案类型
          this.toggleTipsType(4)
          return false;
        }
      }
      
      if(this.getPhoneNumber<1){
        this.$message({
          message: ' 今日次数已用完，可向人才发出邀约获取联系方式哟',
          iconClass:'el-icon-error',
          duration:3000,
        });
        return false;
      }
      if(this.detailState.getPhoneState || ( this.resumeDetail.hr_permission_state==='rejected' || this.resumeDetail.hr_permission_state==='passed')){
        return false;
      }
      //提示
      this.toggleUserinfoTips(true);
      //更新信息弹层 提示文案类型
      this.toggleTipsType(3)
      this.detailState.showGetPhone = true;
    },

    //取消不合适/不合适
    unsuitable(){
      //目前非不合适状态
      if(this.resumeDetail.unsuited){
        
        let { job_application_id } = this.detailItem;
        let data = {
          type:'suited'
        }
        // 直接走接口更改
        actions.job_deliveries.put_job_deliveries_status(job_application_id, data).then(res=>{
          if(res.code===1000){
            //更改取消不合适状态
            this.$emit('updateUnsuitableState',{state:false})
            //更新详情页不合适状态
            this.updateUnsuitableState(false)
          }else{
            this.$message({
            message: res.message,
            type: 'error'
          });
          }
        })
        
      }else{
        //切换弹窗展示状态
        this.$emit('toggleUnsuitableState',true)
      }
    },
    //更新详情页不合适状态
    updateUnsuitableState(state){
      this.resumeDetail.unsuited = state;
      this.updateResumeDetail(this.resumeDetail)
    },
    
    //跳转到聊天页面
    toChatPage(){
      let { cv_account_token } = this.resumeDetail.resume;
      if(!cv_account_token || !this.hr_account_token){
        this.$message({
          message: '对方身份状态异常，无法创建聊天',
          type: 'success'
        });
        return
      }
      let data = {
        b_token: this.hr_account_token,
        c_token: cv_account_token,
        identity: this.resumeDetail.delivery_status ? 'c' : 'b',
        // job_token: item.job_token
      }
      actions.im.post_relationships(data).then(async res=>{
        if(res.code === 1000){
          // 恢复隐藏好友状态
          try {
            await actions.im.putRelationshipsHide({
              b_token: this.hr_account_token, //用户token,
              c_token: cv_account_token, //被曝光的关系id
              b_hide: false, //是否隐藏联系人
            })
          } catch (error) { }
          setTimeout(() => {
            window.open(`${window.location.origin}/talent/chat?chat_id=${cv_account_token}`)
            // this.$router.push({path:'/talent/chat', query:{ chat_id: cv_account_token}})
          }, 300);
        }
      })
    },

  }
}
</script>
<style lang="scss" scoped>
  @import '@/assets/css/components/resumeDetail.scss';
  .span_font_w_b{
    span{
      font-weight: bold !important;
    }
  }
</style>